export default __webpack_public_path__ + "static/media/80s_block_rotate.efd62399.mp3";